import request from '@/router/axios'

export function fetchCommentList (query) {
    return request({
      url: '/post/admin/comments/page',
      method: 'get',
      params: query
    })
}

export function getCommentTotal () {
  return request({
    url: '/post/admin/comments/total',
    method: 'get',
  })
}

export function getComment(id) {
    return request({
      url: '/post/admin/comments/' + id,
      method: 'get'
    })
}

export function putComment (obj) {
  return request({
    url: '/post/admin/comments/banStatus',
    method: 'put',
    data: obj
  })
}

export function fetchCommentLikeList(query) {
  return request({
    url: '/post/admin/like/comment/page',
    method: 'get',
    params: query
  });
}
